"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.text = void 0;
const foundation_1 = require("../foundation");
exports.text = {
    head: {
        ids_textStyle_title_01_base: {
            fontFamily: foundation_1.foundation_text.family.text_itauDisplay_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauDisplay_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_24,
            lineHeight: foundation_1.foundation_size.medium.size_medium_32,
        },
        ids_textStyle_title_01_variant: {
            fontFamily: foundation_1.foundation_text.family.text_itauDisplay_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauDisplay_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_24,
            lineHeight: foundation_1.foundation_size.medium.size_medium_32,
        },
        ids_textStyle_section_01: {
            fontFamily: foundation_1.foundation_text.family.text_itauDisplay_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauDisplay_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_20,
            lineHeight: foundation_1.foundation_size.small.size_small_26,
        },
        ids_textStyle_section_02: {
            fontFamily: foundation_1.foundation_text.family.text_itauDisplay_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauDisplay_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_16,
            lineHeight: foundation_1.foundation_size.small.size_small_24,
        },
        ids_textStyle_overline: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_16,
            lineHeight: foundation_1.foundation_size.small.size_small_24,
        },
        ids_textStyle_subtitle_01: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_16,
            lineHeight: foundation_1.foundation_size.small.size_small_24,
        },
        ids_textStyle_insight_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauDisplay_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauDisplay_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_24,
            lineHeight: foundation_1.foundation_size.medium.size_medium_32,
        },
        ids_textStyle_insight_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauDisplay_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauDisplay_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_24,
            lineHeight: foundation_1.foundation_size.medium.size_medium_32,
        },
    },
    body: {
        ids_textStyle_body_01_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_16,
            lineHeight: foundation_1.foundation_size.small.size_small_24,
        },
        ids_textStyle_body_01_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_16,
            lineHeight: foundation_1.foundation_size.small.size_small_24,
        },
        ids_textStyle_body_02_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_14,
            lineHeight: foundation_1.foundation_size.small.size_small_20,
        },
        ids_textStyle_body_02_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_14,
            lineHeight: foundation_1.foundation_size.small.size_small_20,
        },
        ids_textStyle_caption_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_12,
            lineHeight: foundation_1.foundation_size.small.size_small_18,
        },
        ids_textStyle_caption_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_12,
            lineHeight: foundation_1.foundation_size.small.size_small_18,
        },
    },
    label: {
        ids_textStyle_label_xsmall_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_12,
            lineHeight: foundation_1.foundation_size.small.size_small_18,
        },
        ids_textStyle_label_xsmall_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_12,
            lineHeight: foundation_1.foundation_size.small.size_small_18,
        },
        ids_textStyle_label_small_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_14,
            lineHeight: foundation_1.foundation_size.small.size_small_20,
        },
        ids_textStyle_label_small_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_14,
            lineHeight: foundation_1.foundation_size.small.size_small_20,
        },
        ids_textStyle_label_medium_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_16,
            lineHeight: foundation_1.foundation_size.small.size_small_24,
        },
        ids_textStyle_label_medium_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_16,
            lineHeight: foundation_1.foundation_size.small.size_small_24,
        },
        ids_textStyle_label_large_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_20,
            lineHeight: foundation_1.foundation_size.small.size_small_26,
        },
        ids_textStyle_label_large_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_20,
            lineHeight: foundation_1.foundation_size.small.size_small_26,
        },
        ids_textStyle_label_xlarge_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_24,
            lineHeight: foundation_1.foundation_size.medium.size_medium_32,
        },
        ids_textStyle_label_xlarge_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_24,
            lineHeight: foundation_1.foundation_size.medium.size_medium_32,
        },
    },
    icons: {
        ids_textStyle_icon_small: {
            fontFamily: foundation_1.foundation_text.family.text_itauIcon_family,
            fontWont_size: foundation_1.foundation_size.small.size_small_16,
            lineSeight: foundation_1.foundation_size.small.size_small_16,
        },
        ids_textStyle_icon_medium: {
            fontFamily: foundation_1.foundation_text.family.text_itauIcon_family,
            fontWont_size: foundation_1.foundation_size.small.size_small_24,
            lineSeight: foundation_1.foundation_size.small.size_small_24,
        },
        ids_textStyle_icon_large: {
            fontFamily: foundation_1.foundation_text.family.text_itauIcon_family,
            fontWont_size: foundation_1.foundation_size.medium.size_medium_32,
            lineSeight: foundation_1.foundation_size.medium.size_medium_32,
        },
        ids_textStyle_icon_xlarge: {
            fontFamily: foundation_1.foundation_text.family.text_itauIcon_family,
            fontWont_size: foundation_1.foundation_size.medium.size_medium_48,
            lineSeight: foundation_1.foundation_size.medium.size_medium_48,
        },
    },
    link: {
        ids_textStyle_body_link_01_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_16,
            lineHeight: foundation_1.foundation_size.small.size_small_24,
        },
        ids_textStyle_body_link_01_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_16,
            lineHeight: foundation_1.foundation_size.small.size_small_24,
        },
        ids_textStyle_body_link_01_xbold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_900,
            fontSize: foundation_1.foundation_size.small.size_small_16,
            lineHeight: foundation_1.foundation_size.small.size_small_24,
        },
        ids_textStyle_body_link_02_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_14,
            lineHeight: foundation_1.foundation_size.small.size_small_20,
        },
        ids_textStyle_body_link_02_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_14,
            lineHeight: foundation_1.foundation_size.small.size_small_20,
        },
        ids_textStyle_body_link_02_xbold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_900,
            fontSize: foundation_1.foundation_size.small.size_small_14,
            lineHeight: foundation_1.foundation_size.small.size_small_20,
        },
        ids_textStyle_capition_link_regular: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_400,
            fontSize: foundation_1.foundation_size.small.size_small_12,
            lineHeight: foundation_1.foundation_size.small.size_small_18,
        },
        ids_textStyle_capition_link_bold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_700,
            fontSize: foundation_1.foundation_size.small.size_small_12,
            lineHeight: foundation_1.foundation_size.small.size_small_18,
        },
        ids_textStyle_capition_link_xbold: {
            fontFamily: foundation_1.foundation_text.family.text_itauText_family,
            fontWeight: foundation_1.foundation_text.weight.text_itauText_weight_900,
            fontSize: foundation_1.foundation_size.small.size_small_12,
            lineHeight: foundation_1.foundation_size.small.size_small_18,
        },
    }
};
//# sourceMappingURL=text.js.map